import { render, staticRenderFns } from "./enHeader2.vue?vue&type=template&id=54632e6e&"
import script from "./enHeader2.vue?vue&type=script&lang=js&"
export * from "./enHeader2.vue?vue&type=script&lang=js&"
import style0 from "./enHeader2.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports